import { useEffect } from 'react';
import { useMapContext } from 'widgets/choroplethMap/contexts/mapContext';
import getChoroplethParentLayer from 'widgets/choroplethMap/helpers/getChoroplethParentLayer';
import { Colors } from '@blueprintjs/core';

// source-layers: countries, admin1

export default function useOutlineLayer({
	sourceName,
	layerName,
	sourceLayer,
	minzoom,
	maxzoom,
}: {
	sourceName: string;
	layerName: string;
	sourceLayer: string;
	minzoom: number;
	maxzoom: number;
}) {
	const [{ map }] = useMapContext();

	useEffect(() => {
		if (!map) return;
		map.addLayer(
			{
				id: layerName,
				type: 'line',
				source: sourceName,
				'source-layer': sourceLayer,
				layout: {},
				paint: {
					'line-color': Colors.BLACK,
					'line-opacity': 0.7,
					'line-width': 1,
				},
				minzoom,
				maxzoom,
			},
			getChoroplethParentLayer({ layerName })
		);
	}, [map, sourceName, layerName, maxzoom, minzoom, sourceLayer]);

	// usePolygonHover({ layerName: layerName, sourceName: sourceName, minzoom, maxzoom });
	// useIsVisible({ layerName });
	// useChoroplethFillColor({ sourceName, layerName });
}
